export default "https://assets.pclncdn.com/web/next-landing/01bc7bc/_next/static/images/devices-cd812c0b0efa9ede6916a477c4948da2.jpg";